import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewQuestionComp from "./Component/AddQuestionComp"


const AddQuestion =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewQuestionComp />
        </div>
        <Footer />
        </>
    )
}

export default AddQuestion